export const getIsLoggedIn = (state) => state.isLoggedIn



// WEBPACK FOOTER //
// ./src/redux/auth/selectors.js